// Used in Cart and Order List

import { cUtil }        from "../../functions/util";
import { cCart }        from "../../pages/cart/cart";
import { cProductItem } from "../product-item/product-item";
import { cOrderList }   from "../../pages/order-list/order-list";

export class cOrderListItem implements DateFieldTop {

  div_outer     = document.createElement('div');
  div_header    = document.createElement('div');
  div_meta      = document.createElement('div');
  span_category = document.createElement('span');
  span_listName = document.createElement('span');
  h2_name       = document.createElement('h2');
  a_name        = document.createElement('a');
  div_buttons   = document.createElement('div');
  button_delete = document.createElement('button');
  button_open   = document.createElement('button');
  input_select  = document.createElement('input');

  productItem    : cProductItem;
  nonce          : string;
  inputData      : OrderListItemData;
  isSelected     : boolean;
  parentObj      : OrderItemContainer;

  constructor(
    inputData       : OrderListItemData,
    parentElm       : HTMLElement,
    nonce           : string,
    parentObj       : OrderItemContainer,
    context         : 'single-product' | 'order-list' | 'cart',
   ) {
    const { __, _x, _n, sprintf } = wp.i18n as i18n;

    this.nonce          = nonce;
    this.inputData      = inputData
    this.isSelected     = true;
    this.parentObj      = parentObj;

    const productItemData: SingleProduct = {
      item          : inputData.item,
      product       : inputData.product,
      lists         : [],
      nonce         : nonce,
    }

    // ---- structure ----
    parentElm.append(this.div_outer);
      this.div_outer.append(this.div_buttons);
        this.div_buttons.append(this.input_select);
        this.div_buttons.append(this.button_delete);
        this.div_buttons.append(this.button_open);
      this.div_outer.append(this.a_name);
        this.a_name.append(this.h2_name);
      this.div_outer.append(this.div_meta);
        this.div_meta.append(this.span_category);
        this.div_meta.append(this.span_listName);
      this.div_outer.insertAdjacentHTML('beforeend', inputData.product.image);

      this.productItem = new cProductItem(
        productItemData, 
        this.div_outer,
        this,
        context
      );  

    // ---- Classes ----
    parentElm          .classList.add('c-item-list');
    this.div_outer     .classList.add('c-item');
    this.button_delete .classList.add('button_delete');
    this.button_open   .classList.add('button_open');
    this.input_select  .classList.add('input_select');
    this.span_listName .classList.add('span_listName');
    this.div_buttons   .classList.add('div_buttons');
    this.a_name        .classList.add('a_name');
    this.div_meta      .classList.add('div_meta');

    this.productItem.secondaryPackaging.fieldset_secondaryPackaging.classList.add('c-hidden');

    this.productItem.amounts.fieldset_sellingUnit.style.gridArea = '';
    this.productItem.marinades.fieldset_marinades.style.gridArea = '';


    let slotCount = 1;
    if (!this.productItem.amounts.fieldset_sellingUnit.classList.contains('c-hidden')){
      // this.productItem.amounts.fieldset_sellingUnit .style.gridArea = `c-slot-${slotCount}`;
      this.productItem.amounts.label_sellingUnit    .style.gridArea = `c-slot-${slotCount}-label`;
      this.productItem.amounts.select_sellingUnit   .style.gridArea = `c-slot-${slotCount}-select`;
      slotCount++;
    }
    if (!this.productItem.marinades.fieldset_marinades.classList.contains('c-hidden')){
      // this.productItem.marinades.fieldset_marinades .style.gridArea = `c-slot-${slotCount}`;
      this.productItem.marinades.label_marinades    .style.gridArea = `c-slot-${slotCount}-label`;
      this.productItem.marinades.select_marinades   .style.gridArea = `c-slot-${slotCount}-select`;
      slotCount++;
    }
    if (!this.productItem.secondaryPackaging.fieldset_secondaryPackaging.classList.contains('c-hidden')) {
      // this.productItem.secondaryPackaging.fieldset_secondaryPackaging .style.gridArea = `c-slot-${slotCount}`;
      this.productItem.secondaryPackaging.label_secondaryPackaging    .style.gridArea = `c-slot-${slotCount}-label`;
      this.productItem.secondaryPackaging.select_secondaryPackaging   .style.gridArea = `c-slot-${slotCount}-select`;
      slotCount++;
    }

    // ---- Texts ----
    const status                   = inputData.item.sku === 'none' ? ' ' + __('(gelöscht)', 'custom'): '';
    this.h2_name.textContent       = inputData.product.name + status;
    this.span_category.textContent = `#${inputData.product.sku} — ${inputData.product.category}  — `;
    this.span_listName.textContent = inputData.orderListName === '' ? __('Keine Liste', 'custom') : inputData.orderListName;
    
    // ---- Ohter ----
    const url = new URL(inputData.product.url);
    this.a_name.href          = url.toString();
    this.button_delete.type   = 'button';
    this.button_open.type     = 'button';
    this.input_select.type    = 'checkbox';

    // ---- Events ----
    this.button_delete.addEventListener('click', async() => {

      const data = this.productItem.getData();
      const json = JSON.stringify(data);

      let error: string;
      if (parentObj instanceof cCart) {
        const cart = parentObj.getSaveData(inputData.item.item_id);
        error = await this.fetch(json, 'c_cart_item_delete', cart);
      }
      else {
        error = await this.fetch(json, 'c_order_list_item_delete');
      }

      if (error !== 'ok') {
        parentObj.setErrorMessage(error);
        return;
      }

      if (parentObj instanceof cCart) {
        cUtil.gaSaveData([this.productItem], 'remove_from_cart', 'cart', '');
        window.location.reload();
      }
      else {
        this.div_outer.remove();
        parentObj.deleteItem(inputData.item.item_id);
      }
    });

    this.input_select.addEventListener('change', () => {
      this.isSelected = this.input_select.checked;
      parentObj.changeEvent('cOrderListItem selected');
    });

    this.button_open.addEventListener('click', () => {
      this.div_outer.classList.toggle('c-open');
    });

    // ---- Init ----
    this.input_select.checked = true;
    if (!this.inputData.isDeletable) {
      this.button_delete.classList.add('c-hidden');
    }
    // parentElm.append(this.div_outer);
  }

  changeEvent(eventSource: string): void {
    this.parentObj.changeEvent(eventSource);
  }

  isSelectedAndNotEmpty(): boolean {
    const isOrderlist = this.parentObj instanceof cOrderList; 
    const isEmpty     = this.productItem.isEmpty();

    if (isOrderlist) {
      return this.isSelected && !isEmpty;
    }
    else {
      return true;
    }
  }

  validateItem(silent: 'silent'|'', message: 'list'|'', isSelected?: boolean): boolean {
    const isSelectedAndNotEmpty = this.isSelectedAndNotEmpty();
    return this.productItem.validateItem(silent, message, isSelectedAndNotEmpty);
  }

  async fetch(data: string, action: string, cart: string = ''): Promise<string> {
    const  formData = new FormData();
    formData.append('_ajax_nonce', this.nonce);
    formData.append('action'     , action);
    formData.append('data'       , data);
    if (cart !== '') formData.append('cart', cart);

    const response = await fetch('/wp-admin/admin-ajax.php', {
      method: 'POST',
      body: formData
    });
    const responseData = await response.json() as string;
    return responseData;
  }

  setTabIndex(index: number) {
    this.input_select                             .tabIndex = index + 1;
    this.button_delete                            .tabIndex = index + 2;
    this.button_open                              .tabIndex = index + 3;
    this.a_name                                   .tabIndex = index + 4;
    this.productItem.deliveryDate.date.input      .tabIndex = index + 5;
    this.productItem.amounts.input_amount         .tabIndex = index + 6;
    this.productItem.amounts.select_amountSelect  .tabIndex = index + 7;
    this.productItem.amounts.input_weightPerPiece .tabIndex = index + 8;
    this.productItem.amounts.platter?.setTabIndex(index + 8);
    this.productItem.marinades.select_marinades   .tabIndex = index + 9;
    this.productItem.amounts.select_sellingUnit   .tabIndex = index + 10;
    this.productItem.comment.textarea_comment     .tabIndex = index + 11;
  }

  // ---- Used by cart ----
  getDeliveryDate() {
    return this.productItem.deliveryDate.getDate();
  }
  setDeliveryDate(date: string) {
    this.productItem.deliveryDate.setDate(date);
  }
  getData(): OrderListItem {
    const amounts            = this.productItem.amounts           .getData();
    const secondaryPackaging = this.productItem.secondaryPackaging.getData();
    const marinade           = this.productItem.marinades         .getData();
    const comment            = this.productItem.comment           .getData();
    const deliveryDate       = this.productItem.deliveryDate      .getDate();

    const output: OrderListItem = {
      customer_id         : '',
      list_id             : '',
      item_id             : this.inputData.item.item_id,
      sku                 : this.inputData.item.sku,
      product_id          : this.inputData.item.product_id,
      selling_unit        : amounts.selling_unit,
      amount              : amounts.amount,
      amount_select       : amounts.amount_select,
      weight_per_piece    : amounts.weight_per_piece,
      secondary_packaging : secondaryPackaging,
      marinade            : marinade,
      components          : amounts.components,
      arranged            : amounts.arranged,
      comment             : comment,
      delivery_date       : deliveryDate,
      created             : this.inputData.item.created,
    }
    return output;
  }
}
